<template>
  <div>
    <transition :name="moveName" mode="out-in">
      <router-view :key="key"/>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
    data() {
    return {
      moveName:"slide-list" 
    };
  },
  watch: {
    $route(to, from) {
      // 切换动画
      if (to.meta.index > from.meta.index) {
        this.moveName = "slide-detail";
      } else {
        this.moveName = "slide-list";
      }
    }
  },
  computed:{
    key(){
	    return this.$route.path + Math.random();
	  }
  }
};
</script>

<style lang="scss">
// 进入 
// @keyframes left-out{
//     0%{transform: translateX(0);opacity: 1;}
//     100%{transform: translateX(-100%);opacity: 0;}
// }

// @keyframes right-in{
//     0%{transform: translateX(100%);opacity: 0;}
//     100%{transform: translateX(0%);opacity: 1;}
// }

// // 返回
// @keyframes right-out{
//     0%{transform: translateX(0%);opacity: 1;}
//     100%{transform: translateX(100%);opacity: 0;}
// }

// @keyframes left-in{
//     0%{transform: translateX(-100%);opacity: 0;}
//     100%{transform: translateX(0%);opacity: 1;}
// }

// // 进来
// .slide-detail-enter-active{
//     animation: right-in .3s;
// }

// // 离开 
// .slide-detail-leave-active{
//     animation: left-out .3s;
// }

// // 进来
// .slide-list-enter-active{
//     animation: left-in .3s;
// }

// // 离开
// .slide-list-leave-active{
//     animation: right-out .3s;
// }
</style>